import React, { useState, useEffect } from "react";
import { Star } from "lucide-react";

const StarRating = ({ selectedStars = 0, onSelect }) => {
  const [hover, setHover] = useState(0);
  const [rating, setRating] = useState(selectedStars);

  // Aktualisiert den rating-State, wenn sich selectedStars von außen ändert
  useEffect(() => {
    setRating(selectedStars || 0);
  }, [selectedStars]);

  return (
    <div className="flex items-center !mt-0 !mb-0">
      {[...Array(5)].map((_, index) => {
        index += 1;
        return (
          <button
            type="button"
            key={index}
            className={`${
              index <= (hover || rating) ? "text-yellow-400" : "text-gray-300"
            } bg-transparent border-none cursor-pointer text-2xl focus:outline-none transition-colors duration-200`}
            onClick={() => {
              setRating(index); // Lokalen Zustand aktualisieren
              onSelect(index); // Wert an Parent weitergeben
            }}
            onMouseEnter={() => setHover(index)}
            onMouseLeave={() => setHover(rating)}
          >
            <Star className="w-8 h-8" />
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
